import React, { useCallback, useEffect, useRef } from 'react'

import './LandingPage.scss'

const SCROLL_MARGIN = window.innerHeight / 2 + 30

export const LandingPage = () => {
    const section1 = useRef<HTMLDivElement>(null)
    const section2 = useRef<HTMLDivElement>(null)
    const section3 = useRef<HTMLDivElement>(null)

    const onScroll = useCallback(() => {
        ;[section1, section2, section3].forEach(({ current }) => {
            if (!current) return
            const offsetAndMarge = window.scrollY + SCROLL_MARGIN

            if (
                current.offsetTop <= offsetAndMarge &&
                current.offsetTop + current.clientHeight > offsetAndMarge
            ) {
                current.classList.add('active')
            } else {
                current.classList.remove('active')
            }
        })
    }, [section1, section2, section3])

    useEffect(() => {
        window.addEventListener('scroll', onScroll)
        return () => window.removeEventListener('scroll', onScroll)
    }, [onScroll])

    return (
        <>
            <div className="section" id="section-1" ref={section1}>
                <div className="background" />
                <div className="content">
                    <h1>Développement</h1>
                    <p>Applications Web & Mobile, connectées et temps réel.</p>
                </div>
            </div>
            <div className="section" id="section-2" ref={section2}>
                <div className="background" />
                <div className="content">
                    <h2>Multimedia & M.A.O.</h2>
                    <p>Production numérique et design sonore.</p>
                </div>
            </div>
            <div className="section" id="section-3" ref={section3}>
                <div className="background" />
                <div className="content">
                    <h2>Événementiel</h2>
                    <p>Expériences immersives et colorées !</p>
                </div>
            </div>
        </>
    )
}
